import { render, staticRenderFns } from "./PerAccount.vue?vue&type=template&id=142c5578&"
import script from "./PerAccount.vue?vue&type=script&lang=js&"
export * from "./PerAccount.vue?vue&type=script&lang=js&"
import style0 from "./PerAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports